<div class="avatar-editor position-relative">

  <!-- IMAGE -->
  <div class="avatar-thumb"
       [ngStyle]="{
         'background-image': imageUrl ? 'url(' + imageUrl + ')' : 'none'
       }">

    @if (!imageUrl) {
      <div class="avatar-placeholder d-flex align-items-center justify-content-center">
        <i class="bi bi-person fs-2 text-muted"></i>
      </div>
    }

  </div>

  <!-- ACTION BUTTONS -->
  @if (editable) {
    <div class="avatar-actions">

      <!-- Upload -->
      <label class="btn btn-sm btn-light shadow-sm"
             title="Change image">
        <i class="bi bi-pencil"></i>
        <input type="file"
               hidden
               accept=".png, .jpg, .jpeg"
               (change)="onChangeFile($event)">
      </label>

      <!-- Remove -->
      <button type="button"
              class="btn btn-sm btn-light shadow-sm"
              (click)="onRemoveFile()"
              title="Remove">
        <i class="bi bi-trash"></i>
      </button>

    </div>
  }

</div>